// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see GiftCardManageViewSummaryEvent
 */
export var GiftCardManageViewSummary = function (_a) {
    var giftCardTokens = _a.giftCardTokens, summaryLocation = _a.summaryLocation;
    return ({
        name: "GiftCard Manage ViewSummary",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "Manage",
            gift_card_tokens: giftCardTokens !== undefined && giftCardTokens !== null ? giftCardTokens.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            summary_location: summaryLocation !== undefined && summaryLocation !== null ? summaryLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GiftCardManageViewDetailsEvent
 */
export var GiftCardManageViewDetails = function (_a) {
    var currentDisplayAmount = _a.currentDisplayAmount, status = _a.status, title = _a.title, token = _a.token;
    return ({
        name: "GiftCard Manage ViewDetails",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "Manage",
            current_display_amount: currentDisplayAmount !== undefined && currentDisplayAmount !== null ? currentDisplayAmount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            title: title !== undefined && title !== null ? title.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            token: token !== undefined && token !== null ? token.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GiftCardManageActivateEvent
 */
export var GiftCardManageActivate = function (_a) {
    var token = _a.token;
    return ({
        name: "GiftCard Manage Activate",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "Manage",
            token: token !== undefined && token !== null ? token.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GiftCardManageDeactivateEvent
 */
export var GiftCardManageDeactivate = function (_a) {
    var token = _a.token;
    return ({
        name: "GiftCard Manage Deactivate",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "Manage",
            token: token !== undefined && token !== null ? token.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GiftCardSendInitiateEvent
 */
export var GiftCardSendInitiate = function (_a) {
    var giftCardToken = _a.giftCardToken, giftCardAmount = _a.giftCardAmount, sourceLocation = _a.sourceLocation, flowToken = _a.flowToken, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "GiftCard Send Initiate",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "Send",
            gift_card_token: giftCardToken !== undefined && giftCardToken !== null ? giftCardToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            gift_card_amount: giftCardAmount !== undefined && giftCardAmount !== null ? giftCardAmount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source_location: sourceLocation !== undefined && sourceLocation !== null ? sourceLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GiftCardViewOpenEvent
 */
export var GiftCardViewOpen = function (_a) {
    var sourceLocation = _a.sourceLocation;
    return ({
        name: "GiftCard View Open",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "View",
            source_location: sourceLocation !== undefined && sourceLocation !== null ? sourceLocation.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GiftCardViewTileEvent
 */
export var GiftCardViewTile = function (_a) {
    var giftCardToken = _a.giftCardToken, giftCardSection = _a.giftCardSection, categoryToken = _a.categoryToken, row = _a.row, column = _a.column;
    return ({
        name: "GiftCard View Tile",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "View",
            gift_card_token: giftCardToken !== undefined && giftCardToken !== null ? giftCardToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            gift_card_section: giftCardSection !== undefined && giftCardSection !== null ? giftCardSection.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            category_token: categoryToken !== undefined && categoryToken !== null ? categoryToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            row: row !== undefined && row !== null ? row.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            column: column !== undefined && column !== null ? column.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GiftCardViewCategoryEvent
 */
export var GiftCardViewCategory = function (_a) {
    var categoryToken = _a.categoryToken, count = _a.count;
    return ({
        name: "GiftCard View Category",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "View",
            category_token: categoryToken !== undefined && categoryToken !== null ? categoryToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            count: count !== undefined && count !== null ? count.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GiftCardViewSelectEvent
 */
export var GiftCardViewSelect = function (_a) {
    var giftCardToken = _a.giftCardToken, giftCardSection = _a.giftCardSection, categoryToken = _a.categoryToken, row = _a.row, column = _a.column;
    return ({
        name: "GiftCard View Select",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "View",
            gift_card_token: giftCardToken !== undefined && giftCardToken !== null ? giftCardToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            gift_card_section: giftCardSection !== undefined && giftCardSection !== null ? giftCardSection.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            category_token: categoryToken !== undefined && categoryToken !== null ? categoryToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            row: row !== undefined && row !== null ? row.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            column: column !== undefined && column !== null ? column.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GiftCardSearchEnterTextEvent
 */
export var GiftCardSearchEnterText = function (_a) {
    var count = _a.count, searchText = _a.searchText;
    return ({
        name: "GiftCard Search EnterText",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "Search",
            count: count !== undefined && count !== null ? count.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_text: searchText !== undefined && searchText !== null ? searchText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GiftCardSearchTileEvent
 */
export var GiftCardSearchTile = function (_a) {
    var giftCardToken = _a.giftCardToken, searchText = _a.searchText, row = _a.row, column = _a.column;
    return ({
        name: "GiftCard Search Tile",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "Search",
            gift_card_token: giftCardToken !== undefined && giftCardToken !== null ? giftCardToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_text: searchText !== undefined && searchText !== null ? searchText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            row: row !== undefined && row !== null ? row.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            column: column !== undefined && column !== null ? column.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GiftCardSearchSelectEvent
 */
export var GiftCardSearchSelect = function (_a) {
    var giftCardToken = _a.giftCardToken, searchText = _a.searchText, row = _a.row, column = _a.column;
    return ({
        name: "GiftCard Search Select",
        parameters: {
            cdf_entity: "GiftCard",
            cdf_action: "Search",
            gift_card_token: giftCardToken !== undefined && giftCardToken !== null ? giftCardToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_text: searchText !== undefined && searchText !== null ? searchText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            row: row !== undefined && row !== null ? row.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            column: column !== undefined && column !== null ? column.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
